var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4996,
    cy: 19.5,
    r: 19.4996,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3863 24.2986V10.734C26.3863 9.22476 25.1618 8.00024 23.6525 8.00024H13.9418C12.4325 8.00024 11.208 9.22476 11.208 10.734V24.2986H26.3863ZM18.7924 9.70887C19.248 9.70887 19.6182 10.0791 19.6182 10.5347C19.6182 10.9903 19.248 11.3605 18.7924 11.3605C18.3368 11.3605 17.9666 10.9903 17.9666 10.5347C17.9761 10.0696 18.3368 9.70887 18.7924 9.70887Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 25.9409V27.6685C11.1992 29.1778 12.4237 30.4118 13.933 30.4118H23.6437C25.153 30.4118 26.3775 29.1873 26.3775 27.6685V25.9409H11.1992ZM18.7931 28.8836C18.3375 28.8836 17.9673 28.5133 17.9673 28.0577C17.9673 27.6021 18.3375 27.2319 18.7931 27.2319C19.2487 27.2319 19.6189 27.6021 19.6189 28.0577C19.6189 28.5133 19.2487 28.8836 18.7931 28.8836Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelular);
export default __webpack_public_path__ + "static/media/celular.07ba195bd43e3317e0ddd207c85219b7.svg";
export { ForwardRef as ReactComponent };